import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';

export interface LocalStorageContext {
  values: Record<string, unknown>;
  setValues: Dispatch<SetStateAction<Record<string, unknown>>>;
}

const Context = createContext<LocalStorageContext | null>(null);

export function LocalStorageProvider(props: PropsWithChildren<unknown>) {
  const [values, setValues] = useState<Record<string, unknown>>({});

  return <Context.Provider value={{ values, setValues }}>{props.children}</Context.Provider>;
}

export function useLocalStorageContext() {
  const context = useContext(Context);

  if (!context) {
    throw new Error('useLocalStorageContext must be used within a LocalStorageProvider');
  }

  return context;
}
